import { OptionItem } from "@/types";

export const IndustryLookup = [
  { value: "other", label: "Other" },
] as const satisfies OptionItem[];

export const StateLookup = [
  { value: "1", label: "Abia", item: { capital: "Umuahia" } },
  { value: "2", label: "Adamawa", item: { capital: "Yola" } },
  { value: "3", label: "Akwa Ibom", item: { capital: "Uyo" } },
  { value: "4", label: "Anambra", item: { capital: "Awka" } },
  { value: "5", label: "Bauchi", item: { capital: "Bauchi" } },
  { value: "6", label: "Bayelsa", item: { capital: "Yenagoa" } },
  { value: "7", label: "Benue", item: { capital: "Makurdi" } },
  { value: "8", label: "Borno", item: { capital: "Mavalueuguri" } },
  { value: "9", label: "Cross River", item: { capital: "Calabar" } },
  { value: "10", label: "Delta", item: { capital: "Asaba" } },
  { value: "11", label: "Ebonyi", item: { capital: "Abakaliki" } },
  { value: "12", label: "Edo", item: { capital: "Benin City" } },
  { value: "13", label: "Ekiti", item: { capital: "Ado Ekiti" } },
  { value: "14", label: "Enugu", item: { capital: "Enugu" } },
  { value: "15", label: "FCT, Abuja", item: { capital: "Abuja" } },
  { value: "16", label: "Gombe", item: { capital: "Gombe" } },
  { value: "17", label: "Imo", item: { capital: "Owerri" } },
  { value: "18", label: "Jigawa", item: { capital: "Dutse" } },
  { value: "19", label: "Kaduna", item: { capital: "Kaduna" } },
  { value: "20", label: "Kano", item: { capital: "Kano" } },
  { value: "21", label: "Katsina", item: { capital: "Katsina" } },
  { value: "22", label: "Kebbi", item: { capital: "Birnin Kebbi" } },
  { value: "23", label: "Kogi", item: { capital: "Lokoja" } },
  { value: "24", label: "Kwara", item: { capital: "Ilorin" } },
  { value: "25", label: "Lagos", item: { capital: "Ikeja" } },
  { value: "26", label: "Nasarawa", item: { capital: "Lafia" } },
  { value: "27", label: "Niger", item: { capital: "Minna" } },
  { value: "28", label: "Ogun", item: { capital: "Abeokuta" } },
  { value: "29", label: "Ondo", item: { capital: "Akure" } },
  { value: "30", label: "Osun", item: { capital: "Oshogbo" } },
  { value: "31", label: "Oyo", item: { capital: "Ibadan" } },
  { value: "32", label: "Plateau", item: { capital: "Jos" } },
  { value: "33", label: "Rivers", item: { capital: "Port Harcourt" } },
  { value: "34", label: "Sokoto", item: { capital: "Sokoto" } },
  { value: "35", label: "Taraba", item: { capital: "Janlingo" } },
  { value: "36", label: "Yobe", item: { capital: "Damaturu" } },
  { value: "37", label: "Zamfara", item: { capital: "Gusau" } },
  { value: "0", label: "Other", item: { capital: "Other" } },
] as const satisfies OptionItem[];
